import { Row } from 'src/shared/components/Semantic/all'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const MosaicSectionHeader = () => {
  const { t } = useLocalization()

  return (
    <Row className="items-baseline justify-between gap-4">
      <Row className="items-baseline gap-3">
        <span className="serif text-sm italic text-foreground/40">01</span>
        <h2 className="text-xl font-medium tracking-[-0.01em] md:text-2xl">
          {t('Browse the catalog', 'Bläddra i katalogen')}
        </h2>
      </Row>
    </Row>
  )
}
